import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { map } from 'rxjs';
import { NotificationService } from '../services/notification.service';

export function folderNameBreadcrumbResolver(
  parameterName: string
): ResolveFn<string | undefined | null> {
  return (route, state) => {
    const notificationService = inject(NotificationService);
    if (route.paramMap.keys.some(key => key.endsWith(parameterName))) {
      // Get parameter value
      const value = route.paramMap.get(parameterName);
      if (!!value && value.length > 0) {
        return notificationService.getFolders().pipe(
          map(folders => {
            const folder = folders?.find(
              folder =>
                (!!folder.is_system ? folder.type : folder.name)?.toLowerCase() ===
                value?.toLowerCase()
            );
            if (folder) {
              notificationService.selectedFolder.set(folder);
            }
            return (
              (!!folder?.is_system ? 'shared.notification.' + folder?.type : folder?.name) ||
              'shared.folder'
            );
          })
        );
      }
    }
    return 'shared.folder';
  };
}
